

const maskPhone = (phone) => {
    if (phone) {
        return `+x xxx-xxx-${phone.slice(-4)}`;
    }
    return '';
};

const validateVerificationCode = (input) => {
    const ren = /^([0-9\b])+$/;
    if (input === '' || ren.test(input)) {
        return true;
    }
    return false;
};

export {
    maskPhone,
    validateVerificationCode

};


